<template>
  <div class="about">
    <h1>This is an ranking page</h1>
  </div>
</template>
